export class LabellingEvent {
  task_id: string;
  feature_id: string;
  answer: string;
}
